import { PaidStatuses } from 'tradera/constants/paid-statuses';

export const getTranslatedImageLabel = (t, labelKey) => {
    switch (labelKey) {
        case buyerActiveItemsLabelKeys.RESERVE_PRICE_NOT_REACHED:
        case activeLabelKeys.RESERVE_PRICE_NOT_REACHED:
        case unsoldLabelKeys.RESERVE_PRICE_NOT_REACHED:
            return t('myt_itemCard_imgLabel_reservePriceNotReached');
        case soldLabelKeys.NOT_PAID:
        case purchasesLabelKeys.NOT_PAID:
            return t('myt_itemCard_imgLabel_notPaid');
        case unsoldLabelKeys.NOT_PAID:
            return t('myt_itemCard_imgLabel_unsoldNotPaid');
        case soldLabelKeys.PAYMENT_PENDING:
        case purchasesLabelKeys.PAYMENT_PENDING:
            return t('myt_itemCard_imgLabel_paymentPending');
        case soldLabelKeys.PAID:
        case purchasesLabelKeys.PAID:
            return t('myt_itemCard_imgLabel_paid');
        case soldLabelKeys.DONE:
        case purchasesLabelKeys.DONE:
            return t('myt_itemCard_imgLabel_done');
        case buyerActiveItemsLabelKeys.LEADING:
            return t('myt_itemCard_imgLabel_leading');
        case buyerActiveItemsLabelKeys.OVERBIDDEN:
            return t('myt_itemCard_imgLabel_overbidden');
        case buyerActiveItemsLabelKeys.BID_REMOVED:
            return t('myt_itemCard_imgLabel_bidRemoved');
        case activeLabelKeys.NOT_STARTED:
            return t('myt_itemCard_imgLabel_notStarted');
        case activeLabelKeys.HAS_BIDS:
            return t('myt_itemCard_imgLabel_hasBids');
        case activeLabelKeys.ACTIVE:
            return t('myt_itemCard_imgLabel_active');
        case activeLabelKeys.SOLD:
            return t('myt_itemCard_imgLabel_sold');
        case activeLabelKeys.NOT_SOLD:
            return t('myt_itemCard_imgLabel_notSold');
        case soldLabelKeys.SHIPPING_BOOKED:
            return t('myt_itemCard_imgLabel_shippingBooked');
        case soldLabelKeys.SHIPPED:
        case purchasesLabelKeys.SHIPPED:
            return t('myt_itemCard_imgLabel_shipped');
        case unsoldLabelKeys.FORICBLY_CLOSED:
            return t('myt_itemCard_imgLabel_forciblyClosed');
        case unsoldLabelKeys.RESTARTED:
            return t('myt_itemCard_imgLabel_restarted');
        case itemLostLabelKeys.REMOVED:
            return t('myt_itemCard_imgLabel_removed');
        case itemLostLabelKeys.LOST:
            return t('myt_itemCard_imgLabel_lost');
        default:
            return '';
    }
};

const buyerActiveItemsLabelKeys = {
    RESERVE_PRICE_NOT_REACHED: 'BUYER_RESERVE_PRICE_NOT_REACHED',
    LEADING: 'LEADING',
    OVERBIDDEN: 'OVERBIDDEN',
    BID_REMOVED: 'BID_REMOVED'
};

const activeLabelKeys = {
    NOT_STARTED: 'NOT_STARTED',
    RESERVE_PRICE_NOT_REACHED: 'ACTIVE_RESERVE_PRICE_NOT_REACHED',
    HAS_BIDS: 'HAS_BIDS',
    ACTIVE: 'ACTIVE',
    SOLD: 'SOLD',
    NOT_SOLD: 'NOT_SOLD'
};

const soldLabelKeys = {
    NOT_PAID: 'SOLD_NOT_PAID',
    PAYMENT_PENDING: 'PAYMENT_PENDING',
    PAID: 'SOLD_PAID',
    SHIPPING_BOOKED: 'SHIPPING_BOOKED',
    SHIPPED: 'SHIPPED',
    DONE: 'SOLD_DONE'
};

const unsoldLabelKeys = {
    NOT_PAID: 'UNSOLD_NOT_PAID',
    RESERVE_PRICE_NOT_REACHED: 'UNSOLD_RESERVE_PRICE_NOT_REACHED',
    FORICBLY_CLOSED: 'FORCIBLY_CLOSED',
    RESTARTED: 'RESTARTED'
};

const purchasesLabelKeys = {
    NOT_PAID: 'PURHCASED_NOT_PAID',
    PAYMENT_PENDING: 'PAYMENT_PENDING',
    PAID: 'PURCHASED_PAID',
    SHIPPED: 'SHIPPED',
    DONE: 'PURCHASED_DONE'
};

const itemLostLabelKeys = {
    LOST: 'LOST',
    REMOVED: 'ITEMLOST_REMOVED '
};

const buyerActiveItemsLabels = {
    reservePriceNotReached: {
        key: buyerActiveItemsLabelKeys.RESERVE_PRICE_NOT_REACHED,
        color: 'red'
    },
    leading: {
        key: buyerActiveItemsLabelKeys.LEADING,
        color: 'green'
    },
    overbidden: {
        key: buyerActiveItemsLabelKeys.OVERBIDDEN,
        color: 'red'
    },
    bidRemoved: {
        key: buyerActiveItemsLabelKeys.BID_REMOVED,
        color: 'grey-hard'
    }
};

const activeLabels = {
    notStarted: {
        key: activeLabelKeys.NOT_STARTED,
        color: 'grey-soft'
    },
    reservePriceNotReached: {
        key: activeLabelKeys.RESERVE_PRICE_NOT_REACHED,
        color: 'red'
    },
    hasBids: { key: activeLabelKeys.HAS_BIDS, color: 'green' },
    active: { key: activeLabelKeys.ACTIVE, color: 'blue' },
    sold: { key: activeLabelKeys.SOLD, color: 'green' },
    notSold: {
        key: activeLabelKeys.NOT_SOLD,
        color: 'grey-soft'
    }
};

const unsoldLabels = {
    notPaid: {
        key: unsoldLabelKeys.NOT_PAID,
        color: 'grey-hard'
    },
    reservePriceNotReached: {
        key: unsoldLabelKeys.RESERVE_PRICE_NOT_REACHED,
        color: 'red'
    },
    forciblyClosed: {
        key: unsoldLabelKeys.FORICBLY_CLOSED,
        color: 'red'
    },
    restarted: {
        key: unsoldLabelKeys.RESTARTED,
        color: 'blue'
    }
};

const purchasesLabels = {
    notPaid: {
        key: purchasesLabelKeys.NOT_PAID,
        color: 'red'
    },
    paymentPending: {
        key: purchasesLabelKeys.PAYMENT_PENDING,
        color: 'red'
    },
    paid: { key: purchasesLabelKeys.PAID, color: 'green' },
    shipped: { key: purchasesLabelKeys.SHIPPED, color: 'dark-highlighted' },
    done: { key: purchasesLabelKeys.DONE, color: 'grey-hard' }
};

const itemLostLabels = {
    lost: {
        key: itemLostLabelKeys.LOST,
        color: 'grey-hard'
    },
    removed: {
        key: itemLostLabelKeys.REMOVED,
        color: 'grey-hard'
    }
};

export const itemHasBids = (item) => item.bidInformation.bidCount > 0;
export const itemHasBidsButReservePriceNotReached = (item) =>
    item.transaction
        ? false
        : itemHasBids(item) &&
          !item.reservePriceReached &&
          item.listing.pricing.reservePrice !== -1;

const getActiveActiveLabel = (item) => {
    if (itemHasBidsButReservePriceNotReached(item)) {
        return activeLabels.reservePriceNotReached;
    }
    return itemHasBids(item) ? activeLabels.hasBids : activeLabels.active;
};

export const getActiveLabel = (item) => {
    switch (item.activityType) {
        case 'NotPublished':
            return activeLabels.notStarted;
        case 'Active':
            return getActiveActiveLabel(item);
        case 'Sold':
            return activeLabels.sold;
        case 'Unsold':
            return activeLabels.unSold;
    }
};

export const getUnsoldLabel = (item) => {
    if (item && item.listing.restart.hasRestartedChild) {
        return unsoldLabels.restarted;
    }
    if (item && item.forciblyClosed && item.forciblyClosed.closed) {
        return unsoldLabels.forciblyClosed;
    }
    if (itemHasBidsButReservePriceNotReached(item)) {
        return unsoldLabels.reservePriceNotReached;
    }
    return unsoldLabels.notPaid;
};

const getStates = (sellerState) => ({
    paid: sellerState.paid ? 'done' : '',
    shipped: sellerState.shipped
        ? 'done'
        : sellerState.shippingBooked
          ? 'partial'
          : '',
    feedbackLeft: sellerState.feedbackLeft ? 'done' : ''
});

export const getBuyerActiveItemsLabel = (item, memberId) => {
    if (item.caller.leadingBidRemoved === true) {
        return buyerActiveItemsLabels.bidRemoved;
    }

    if (
        item.bidInformation.leadingBidder &&
        item.bidInformation.leadingBidder.id === memberId
    ) {
        if (!item.reservePriceReached) {
            return buyerActiveItemsLabels.reservePriceNotReached;
        }
        return buyerActiveItemsLabels.leading;
    } else {
        return buyerActiveItemsLabels.overbidden;
    }
};

export const getPurchasesLabel = (item) => {
    const buyerState = item.transaction.buyerState;
    const states = getStates(buyerState);

    if (item.transaction.paidStatus === PaidStatuses.PAYMENT_PENDING) {
        return {
            ...purchasesLabels.paymentPending,
            states: states
        };
    }

    if (buyerState.paid && buyerState.feedbackLeft) {
        return {
            ...purchasesLabels.done,
            states: states
        };
    }

    if (buyerState.paid && buyerState.shipped) {
        return {
            ...purchasesLabels.shipped,
            states: states
        };
    }

    if (buyerState.paid) {
        return {
            ...purchasesLabels.paid,
            states: states
        };
    }

    return {
        ...purchasesLabels.notPaid,
        states: states
    };
};

export const getBuyerItemsLostLabel = (item) => {
    if (item && item.forciblyClosed && item.forciblyClosed.closed) {
        return {
            ...itemLostLabels.removed
        };
    }

    return {
        ...itemLostLabels.lost
    };
};
